import { createContext } from 'react';

const ProgressListContext = createContext<() => void>(null);

export default ProgressListContext;
